<div class="popup-div">
  <p (click)="openColumnSelect()">Manage Columns</p>
  <!-- <p (click)="resetColumn()">Reset Columns</p> -->
</div>